import { loadLocaleMessages } from '@/utils/locale';

import { EasyshipLocale } from './types';

const StoreData = {
  currentLocale: null,
  messagesCache: null,
  fetchingLocale: null,
} as {
  currentLocale: EasyshipLocale | null;
  messagesCache: Record<string, string> | null;
  fetchingLocale: EasyshipLocale | null;
};

type Listener = () => void;

const createLocalizeStore = () => {
  const listeners = new Set<Listener>();

  const setMessages = (locale: EasyshipLocale, messages: Record<string, string> | null) => {
    StoreData.messagesCache = messages;
    StoreData.currentLocale = locale;
    listeners.forEach((notify) => notify());
  };

  return {
    getData: () => StoreData.messagesCache,
    fetchData: async (localeCode: EasyshipLocale) => {
      if (
        (StoreData.currentLocale === localeCode && StoreData.messagesCache) ||
        StoreData.fetchingLocale === localeCode
      ) {
        return;
      }

      StoreData.fetchingLocale = localeCode;
      const loadedMessages = await loadLocaleMessages(localeCode);
      setMessages(localeCode, loadedMessages);
      StoreData.fetchingLocale = null;
    },
    subscribe: (listener: Listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
};

const localizeStore = createLocalizeStore();

export { localizeStore };

export const fetchLocalize = async (local: EasyshipLocale) => localizeStore.fetchData(local);
